import CHARGE_TYPE from 'constants/payment/chargeType.const';
import DEPOSIT_ACTION from 'constants/payment/depositAction.const';

const CHARGE_TO_DEPOSIT = Object.freeze({
  [CHARGE_TYPE.keep]: DEPOSIT_ACTION.keep,
  [CHARGE_TYPE.refund]: DEPOSIT_ACTION.refund,
  [CHARGE_TYPE.noShowBank]: DEPOSIT_ACTION.bankDeposit,
  [CHARGE_TYPE.noShowCharge]: DEPOSIT_ACTION.bankCharges,
});

// noinspection JSUnusedGlobalSymbols
export default CHARGE_TO_DEPOSIT;
